export default {
  'variable.title': 'Gestionar Variables',
  'variable.form.initialValue': 'Valor Inicial',
  'variable.form.nameInvalid':
    'El nombre solo puede contener letras, números y guiones bajos, y no puede empezar con un número.',
  'variable.form.text': 'Texto',
  'variable.form.number': 'Numérico',
  'variable.form.datetime': 'Fecha y Hora',
  'variable.form.date': 'Fecha',
  'variable.form.time': 'Hora',
  'variable.form.array': 'Matriz',
  'variable.form.object': 'Objeto',
};
